import { BehaviorSubject } from 'rxjs'

import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'
import { router } from '../router'

const currentUserSubject = new BehaviorSubject(
  JSON.parse(
    localStorage.getItem('currentUser') || sessionStorage.getItem('currentUser')
  )
)

const currentContentTypeSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem('currentContentType'))
)

export const authenticationService = {
  login,
  logout,
  refresh,
  activeDirectoryLogin,
  getAllContentTypes,
  currentContentType: currentUserSubject.asObservable(),
  get currentContentTypeValue () {
    return currentContentTypeSubject.value
  },
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue () {
    return currentUserSubject.value
  }
}

function login (username, password, isRemember) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/token/`
  return fetch(url, requestOptions.post({ username, password }))
    .then(handleResponse)
    .then(user => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      if (isRemember) {
        localStorage.setItem('currentUser', JSON.stringify(user))
      } else {
        localStorage.setItem('currentUser', JSON.stringify(user))
      }
      currentUserSubject.next(user)

      return user
    })
}

function activeDirectoryLogin (user) {
  localStorage.setItem('currentUser', JSON.stringify(user))
  currentUserSubject.next(user)

  return user
}

function refresh () {
  if (!this.currentUserValue) {
    return
  }
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/token/refresh/`
  return fetch(
    url,
    requestOptions.post({ refresh: this.currentUserValue.refresh })
  )
    .then(handleResponse)
    .then(user => {
      if (!user || !user.access) {
        this.logout()
      }
    })
    .catch(() => {
      this.logout()
    })
}

function getAllContentTypes () {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/content-types/?limit=9999999`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(rs => {
      localStorage.setItem('currentContentType', JSON.stringify(rs.results))
      currentContentTypeSubject.next(rs.results)
      return rs
    })
}

function logout () {
  // remove user from local storage to log user out
  localStorage.removeItem('currentUser')
  sessionStorage.removeItem('currentUser')
  localStorage.removeItem('currentContentType')
  localStorage.removeItem('userInfo')
  currentUserSubject.next(null)
  currentContentTypeSubject.next(null)
  router.push('/login')
}

// eslint-disable-next-line no-unused-vars
function parseJwt (token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}



// WEBPACK FOOTER //
// ./src/services/authentication.service.js